import React from 'react';
import Wrapper from '../components/Wrapper/Wrapper';

const PrivacyPolicy = () => {
    return (
        <Wrapper>
            <div style={{ marginBottom: '4em' }}>
                <p><strong>Informativa sulla Privacy di Rossomotori.it</strong></p>

                <p><strong>1. Introduzione</strong></p>
                <p>Rossomotori.it (“Sito”) si impegna a proteggere la privacy degli utenti. Questa Informativa sulla Privacy descrive come raccogliamo, utilizziamo, condividiamo e proteggiamo i dati personali degli utenti in conformità al Regolamento Generale sulla Protezione dei Dati (GDPR – Regolamento UE 2016/679).</p>

                <p><strong>2. Titolare del Trattamento</strong></p>
                <p>Il Titolare del Trattamento dei dati è Rossomotori.it, con sede legale in [Indirizzo], contattabile all’indirizzo email: <a href="mailto:privacy@rossomotori.it">privacy@rossomotori.it</a>.</p>

                <p><strong>3. Dati Personali Raccolti</strong></p>
                <ul>
                    <li><strong>Dati forniti direttamente dall’utente:</strong> Nome, cognome, indirizzo email, e altre informazioni fornite tramite form di contatto o registrazione.</li>
                    <li><strong>Dati raccolti automaticamente:</strong> Indirizzo IP, tipo di dispositivo, dati di navigazione e preferenze tramite cookie e tecnologie simili.</li>
                </ul>

                <p><strong>4. Finalità del Trattamento</strong></p>
                <p>I dati personali sono trattati per le seguenti finalità:</p>
                <ul>
                    <li>Gestione delle richieste inviate tramite form di contatto.</li>
                    <li>Invio di newsletter o comunicazioni promozionali, previo consenso dell’utente.</li>
                    <li>Analisi statistica per migliorare i servizi offerti.</li>
                    <li>Adempimento di obblighi legali e normativi.</li>
                </ul>

                <p><strong>5. Base Giuridica del Trattamento</strong></p>
                <p>Il trattamento dei dati è basato su:</p>
                <ul>
                    <li>Il consenso dell’utente, ove richiesto (es. per l’invio di newsletter).</li>
                    <li>L’esecuzione di un contratto o misure precontrattuali.</li>
                    <li>L’adempimento di obblighi legali.</li>
                    <li>Il legittimo interesse del Titolare, ad esempio per migliorare i servizi offerti.</li>
                </ul>

                <p><strong>6. Conservazione dei Dati</strong></p>
                <p>I dati personali sono conservati per il tempo necessario a raggiungere le finalità per cui sono stati raccolti o per adempiere agli obblighi legali. I dati utilizzati a fini di marketing saranno conservati fino alla revoca del consenso.</p>

                <p><strong>7. Condivisione dei Dati</strong></p>
                <p>I dati personali possono essere condivisi con:</p>
                <ul>
                    <li>Fornitori di servizi terzi che supportano il Sito (es. hosting, analisi).</li>
                    <li>Autorità competenti, ove richiesto dalla legge.</li>
                    <li>Partner commerciali, previo consenso dell’utente.</li>
                </ul>

                <p><strong>8. Diritti degli Utenti</strong></p>
                <p>Gli utenti hanno il diritto di:</p>
                <ul>
                    <li>Accedere ai propri dati personali.</li>
                    <li>Richiedere la rettifica o la cancellazione dei dati.</li>
                    <li>Opporsi al trattamento o richiederne la limitazione.</li>
                    <li>Portare i propri dati personali (diritto alla portabilità).</li>
                    <li>Revocare il consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento basato sul consenso prima della revoca.</li>
                </ul>
                <p>Per esercitare tali diritti, è possibile contattare il Titolare all’indirizzo email: <a href="mailto:info@rossomotori.it">info@rossomotori.it</a>.</p>

                <p><strong>9. Sicurezza dei Dati</strong></p>
                <p>Rossomotori.it adotta misure tecniche e organizzative adeguate per proteggere i dati personali degli utenti da accessi non autorizzati, perdite o divulgazioni.</p>

                <p><strong>10. Modifiche all’Informativa sulla Privacy</strong></p>
                <p>Rossomotori.it si riserva il diritto di aggiornare questa informativa in qualsiasi momento. Gli utenti saranno informati di eventuali modifiche tramite avvisi sul Sito.</p>

                <p><strong>11. Contatti</strong></p>
                <p>Per ulteriori informazioni o richieste relative alla privacy, è possibile contattare Rossomotori.it all’indirizzo email: <a href="mailto:info@rossomotori.it">info@rossomotori.it</a>.</p>

            </div>
        </Wrapper>
    );
}

export default PrivacyPolicy;